import { Component, EventEmitter } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
  selector: 'app-vipinfo-edit-popup-modal',
  templateUrl: './vipinfo-edit-popup-modal.component.html',
})
export class VipinfoEditPopupModalComponent {
  // popup content given by the parent component
  public popupContent: string;
  // event when saving the updated poupup
  public save: EventEmitter<string>;
  // event when canceling the changes
  public cancel: EventEmitter<void>;

  // connfiguration of the editor
  public editorConfig: AngularEditorConfig;

  constructor() {
    // initialize variables
    this.save = new EventEmitter<string>();
    this.cancel = new EventEmitter<void>();
    this.editorConfig = {
      editable: true,
      sanitize: true,
      minHeight: '500px',
      minWidth: '600px',
      toolbarHiddenButtons: [
        [
          'undo',
          'redo',
          'underline',
          'strikeThrough',
          'subscript',
          'superscript',
          'indent',
          'outdent',
          'heading',
          'fontName',
        ],
        [
          'fontSize',
          'textColor',
          'backgroundColor',
          'customClasses',
          'link',
          'unlink',
          'insertImage',
          'insertVideo',
          'insertHorizontalRule',
          'removeFormat',
          'toggleEditorMode',
        ],
      ],
    };
  }

  // function to emit the save event
  onSave(): void {
    this.save.emit(this.popupContent);
  }
  // function to emit the cancel event
  onCancel(): void {
    this.cancel.emit();
  }
}
